import {Component} from "@angular/core";
import {IT_VIEW_TITLE_CONTROLLER, IViewTitleController, MK_VIEW_TITLE} from "../_controllers/IViewTitleController";
import {ViewTitleController} from "../_controllers/view-title.controller";
import {ViewTitleModel} from "../_models/ViewTitleModel";
import {AbstractView} from "../../../views/AbstractView";

@Component({
  selector: 'link-view-title',
  templateUrl: './view-title.view.html',
  styleUrls: ['./view-title.view.scss'],
  providers: [
    {provide: IT_VIEW_TITLE_CONTROLLER, useClass: ViewTitleController}
  ]
})
export class ViewTitleView extends AbstractView<IViewTitleController> {

  protected readonly model: ViewTitleModel;

  constructor() {
    super(IT_VIEW_TITLE_CONTROLLER);

    this.model = this.getController().getModel(MK_VIEW_TITLE);
  }
}
